export interface ResolveClientIdInput {
	urlClientId: string | null | undefined;
	envClientId: string | null | undefined;
}

export const resolveClientId = ({ urlClientId, envClientId }: ResolveClientIdInput): string | null => {
	if (urlClientId) return urlClientId;
	if (envClientId) return envClientId;
	return null;
};
